export default __webpack_public_path__ + "static/media/trampapo_02_18.8a9070b5.jpg";